import React from "react";
import Modal from "../../Atoms/Modal/Modal";
import styles from "./NewsCouncilInfoModal.module.scss";
import calendarIcon from "../../../assets/Imagess/calendar-black.svg";
import Buttons from "../../Atoms/Buttons/Buttons";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import he from "he";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

const NewsCouncilInfoModal = ({ news, handleOnClose, setShowDeletePopup }) => {
  const navigate = useNavigate();

  const decodedHTML = news ? he.decode(news.newsTextEn) : "";

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px' }}
    >
      <div>
        <img
          src={sanitizeAndValidateUrl(`${news?.url}${news?.image}`)}
          className={styles['modal-image']}
        />
      </div>
      <div className={styles['title-container']}>
        <p className={styles['title']}>{news?.title_EN}</p>
      </div>
      <div className={styles['info-container']}>
        <p className={styles['category-name']}>{news?.category_EN}</p>
        <div className={styles['date-time-container']}>
          <div className={styles['date-time-item']}>
            <img src={calendarIcon} />
            <p>{moment(news?.newsDate).format('DD/MM/yyyy')}</p>
          </div>
        </div>
        <div
          className={styles['date-time-container']}
          style={{ marginTop: '16px', marginBottom: '16px' }}
        >
          <div className={styles['date-time-item']}>
            <p
              className={styles['text']}
              dangerouslySetInnerHTML={{ __html: decodedHTML }}
            />
          </div>
        </div>
        <div className={styles['text-container']}>
          <p>{news?.newsTextEN}</p>
        </div>
        <div className={styles['button-container']}>
          <Buttons
            text="تعديل"
            color="#0DA06E"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => navigate(`/home/edit-news/${news?.newsId}`)}
          />
          <Buttons
            text="حذف"
            color="#D72222"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => {
              handleOnClose();
              setShowDeletePopup(true);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default NewsCouncilInfoModal;
